import { jsx as _jsx } from "react/jsx-runtime";
import { AdminDashboard } from '../components/dashboard/AdminDashboard';
import { EmployeeDashboard } from '../components/dashboard/EmployeeDashboard';
import { GettingStarted, useNeedsOnboarding } from '../components/dashboard/GettingStarted';
import { ManagerDashboard } from '../components/dashboard/ManagerDashboard';
import { useAuthStore } from '../stores/auth.store';
export default function Dashboard() {
    const { user } = useAuthStore();
    const { needsOnboarding, isLoading: onboardingLoading } = useNeedsOnboarding();
    // Determine which dashboard to show based on user role
    // Priority: Admin > Manager > Employee
    const isAdmin = user?.roles?.includes('admin');
    const isManager = user?.roles?.includes('manager');
    const isEmployee = user?.roles?.includes('employee');
    // Show manager dashboard if user is a manager (even if also employee)
    if (isManager && !isAdmin) {
        return _jsx(ManagerDashboard, {});
    }
    // Show employee dashboard for pure employees (not manager or admin)
    if (isEmployee && !isManager && !isAdmin) {
        return _jsx(EmployeeDashboard, {});
    }
    // Show loading while checking onboarding status
    if (onboardingLoading) {
        return (_jsx("div", { className: "flex items-center justify-center min-h-[400px]", children: _jsx("div", { className: "animate-spin rounded-full h-8 w-8 border-b-2 border-brand-600" }) }));
    }
    // Show Getting Started for new accounts (admin only)
    if (needsOnboarding && isAdmin) {
        return _jsx(GettingStarted, {});
    }
    return _jsx(AdminDashboard, {});
}
